import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CSSModules from 'react-css-modules';
import Link from '../common/link';

import styles from './cta-button.module.scss';

const CtaButton = ({ children, to, isDark }) => (
  <div styleName="container">
    <Link to={to} styleName={classnames('button', { dark: isDark })} className="button">
      {children}
    </Link>
  </div>
);
CtaButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  to: PropTypes.string,
  isDark: PropTypes.bool,
};
CtaButton.defaultProps = {
  children: undefined,
  to: '',
  isDark: false,
};

export default CSSModules(CtaButton, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/cta-button.jsx